import { CURRENCY_CODE } from "../constants";

/**
 * i18n document key passed to `loginActions.downloadDocumentI18n` for account-opening TyC PDFs.
 */
export function resolveAccountOpeningTyCTermsDocumentKey(accountType, isRetailEnvironment) {
    if (accountType === 7) {
        return "checkingAccount.CA.opening.retail.termsAndConditions";
    }
    const segment = isRetailEnvironment ? "retail" : "corporate";
    return `checkingAccount.usd.opening.${segment}.termsAndConditions`;
}

/** Label injected into `accounts.new.termsAndConditions.title` (`tipoCuenta`). */
export function resolveAccountOpeningTyCAccountTypeLabel(accountType) {
    switch (accountType) {
        case 3:
            return "corrientes";
        case 7:
            return "de ahorros";
        default:
            return "corrientes especiales";
    }
}

/** Currency word for `accounts.new.termsAndConditions.title` (`moneda`). */
export function resolveAccountOpeningTyCCurrencyLabel(currency) {
    return `${currency}` === CURRENCY_CODE.USD ? "dólares" : "pesos";
}
